import React from 'react';

import { WarehouseCalendarPage } from '@components/admin/agency/WarehouseCalendarPage';

export const WarehouseCalendar: React.FC = () => {
  return <WarehouseCalendarPage isAdmin={false} />;
};
